export default __webpack_public_path__ + "static/media/master_jinka.8bc4d328.png";